import React from "react";
import HashboardHeatMapCS from "./HashboardHeatMap";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

const HashboardHeatMapPageCS = () => {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: { retry: 0 },
        },
    });
    return (
        <QueryClientProvider client={queryClient}>
            <HashboardHeatMapCS/>
        </QueryClientProvider>
    );
}

export default HashboardHeatMapPageCS;